var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('list', {
    staticClass: "legal-texts-cell uk-margin-remove",
    attrs: {
      "items": _vm.legalTexts,
      "type": "bullet"
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'legal-text',
              params: {
                id: item.id
              }
            },
            "title": item.plainBody
          }
        }, [_vm._v("\n      " + _vm._s(_vm._f("truncate")(item.plainBody, 100)) + "\n    ")])]
      }
    }])
  }, [_c('text-placeholder', {
    slot: "empty"
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3bc62aea","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/LegalTextsCell.vue
// module id = 1939
// module chunks = 0